import { params } from '../modules/events/movePages';
import { apiClient } from '../utils/api';
import { getLocalTimezoneName } from '../utils/getLocalTimezoneName';

export async function createLead(data) {
    if (parseInt(params('has_source')) === 1) {
        data['source'] = params('source');
    }
    return await apiClient.POST(`api/leads`, data);
}

export async function updateLead(id, data) {
    return await apiClient.POST(`api/leads/${id}`, data);
}

/**
 * @param {object} [identity] Name/email/phone the visitor TYPED into this widget.
 *   Sent on the consult step only, so a widget with an intake handoff configured
 *   can hand back a signed `intake_redirect_url` whose token prefills the intake
 *   form. Server-side the values only ever come back to the browser that typed
 *   them — see IntakeHandoff::urlForLead.
 */
export async function updateLeadStep(id, step, sessionEnded = 'false', identity = {}) {

    if (step === 'question') {
        return await apiClient.PUT(
            `api/leads/${id}/step/${step}/true`
        );
    }

    if (step === 'consult') {
        const timezone = getLocalTimezoneName();
        // widget_uuid tells the API WHICH widget this consult came through, so a
        // test widget can run the intake handoff while the live one does not.
        const widgetUuid = params('form_id') || params('form');
        return await apiClient.PUT(
            `api/leads/${id}/step/${step}${sessionEnded ? `/${sessionEnded}` : ''}`,
            {
                ...(timezone && { timezone }),
                ...(widgetUuid && { widget_uuid: widgetUuid }),
                ...identity,
            }
        );
    }

    return await apiClient.PUT(
        `api/leads/${id}/step/${step}${sessionEnded ? `/${sessionEnded}` : ''}`
    );
}

/**
 * Same as updateLeadStep, but fetch + keepalive (NOT axios) so the request
 * survives a top-frame navigation that fires shortly after — e.g. the
 * configured post-booking redirect (see triggerCalendarRedirectIfConfigured
 * in movePages.js), which navigates window.top a couple seconds later and
 * would otherwise abort a fire-and-forget XHR still in flight.
 */
export function updateLeadStepKeepalive(id, step, sessionEnded = 'false') {
    try {
        return fetch(apiClient.apiUrl(`api/leads/${id}/step/${step}${sessionEnded ? `/${sessionEnded}` : ''}`), {
            method: 'PUT',
            keepalive: true,
            headers: apiClient.config().headers,
        }).catch(() => null);
    } catch (e) {
        return Promise.resolve(null);
    }
}

/**
 * End the lead's widget session immediately (drop-off collection).
 * Uses fetch + keepalive (NOT axios) so the request survives page unload
 * when fired from pagehide, and keeps flying if the tab closes mid-request.
 */
export function endLeadSession(id) {
    try {
        return fetch(apiClient.apiUrl(`api/leads/${id}/end-session`), {
            method: 'POST',
            keepalive: true,
            headers: apiClient.config().headers,
        }).catch(() => null);
    } catch (e) {
        return Promise.resolve(null);
    }
}
